/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";

class ThemeRolling extends Component {
  state = {};
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const banner = result.data[0].listData;
    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          banner,
        });
      }
    }
  };
  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + "/themeBanner", {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
      });
  };
  _onTheme = (themeSerial) => {
    const { history } = this.props;
    history.push("/theme");
    //history.push('/tlist?ts=' + themeSerial)
  };
  _renderBanner = () => {
    const { banner } = this.state;

    const list = banner.map((item, index) => {
      return (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => this._onTheme(item.themeSerial)}
          key={index}
        >
          <img
            src={
              "https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/theme/" + item.imageS
            }
            style={{ cursor: "pointer" }}
          />
        </div>
      );
    });

    return list;
  };
  render() {
    const { banner } = this.state;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    };
    return (
      <div>
        <Slider ref={(ref) => (this.slider = ref)} {...settings}>
          {banner ? this._renderBanner() : null}
        </Slider>
      </div>
    );
  }
}

export default shopContext(withRouter(ThemeRolling));
